import React from "react";
import { AlertTriangle } from "lucide-react";
import { fmt } from "@/lib/api";

export default function AlertBanner({ alerts }) {
  if (!alerts || alerts.length === 0) return null;
  return (
    <div
      data-testid="threshold-alert-banner"
      className="alert-pulse w-full rounded-xl border-2 border-red-500 bg-red-50 p-4 shadow-sm"
    >
      <div className="flex items-center gap-2 mb-2">
        <AlertTriangle className="h-6 w-6 text-red-600 shrink-0" strokeWidth={2.5} />
        <span className="font-display font-extrabold uppercase tracking-tight text-red-800 text-lg">
          {alerts.length} alerte{alerts.length > 1 ? "s" : ""} de seuil
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {alerts.map((a, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-1.5 rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-semibold text-red-900"
          >
            {a.site_name} · {a.type_label}
            <span className="font-data font-bold">
              {a.total_piles ?? fmt(a.total)} / {a.seuil_piles ?? fmt(a.seuil)} (piles)
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
